import "../../styles/Contact.css";
import { useState, useEffect } from "react";
import { FaPhone, FaLocationArrow, FaEnvelopeOpen, FaWhatsapp } from "react-icons/fa";
import { collection, addDoc } from "firebase/firestore"; // Firebase Firestore
import { db } from "../../firebase/firebaseConfig"; // Import your Firebase configuration
import emailjs from "emailjs-com"; // For sending emails

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState(null);
  const [autoCloseTimer, setAutoCloseTimer] = useState(0);

  // Handle form data changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setFeedbackMessage(null);

    try {
      // Send email using EmailJS
      await emailjs.send(
        "service_yourServiceId", // Replace with your EmailJS Service ID
        "template_yourTemplateId", // Replace with your EmailJS Template ID
        {
          from_name: formData.name,
          subject: formData.subject,
          message: formData.message,
          reply_to: formData.email,
        },
        "your_public_key" // Replace with your EmailJS Public Key
      );

      // Save the data to Firestore
      await addDoc(collection(db, "contactMessages"), {
        name: formData.name,
        email: formData.email,
        subject: formData.subject,
        message: formData.message,
        timestamp: new Date(),
      });

      setFeedbackMessage({ type: "success", text: "Message sent successfully!" });
      setAutoCloseTimer(100); // Initialize the countdown percentage
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (error) {
      console.error("Error submitting the message:", error);
      setFeedbackMessage({ type: "error", text: "Failed to send the message. Please try again." });
      setAutoCloseTimer(100);
    } finally {
      setLoading(false);
    }
  };

  // Auto-close timer effect
  useEffect(() => {
    if (autoCloseTimer > 0) {
      const interval = setInterval(() => {
        setAutoCloseTimer((prev) => prev - 1);
      }, 50); // Adjust for smoother animation

      if (autoCloseTimer <= 0) {
        setFeedbackMessage(null);
      }

      return () => clearInterval(interval);
    }
  }, [autoCloseTimer]);

  return (
    <section className="contact-section text-dark2 dark:text-light1" id="contact-section">
      <div className="contact-div">
        <h1 className="contact-h1" data-aos="fade-in" data-aos-duration="1000">
          Contact
        </h1>
        <h2 className="contact-h2" data-aos="fade-up" data-aos-duration="1100">
          Get a question? Contact our customer care representative.
        </h2>
        <div className="contact-div2">
          <div className="contact-details">
            <ul className="contact-list-item-container">
              <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1000">
                <span className="contact-list-icon bg-light2 dark:bg-dark2">
                  <FaLocationArrow />
                </span>{" "}
                <span>No5 Maryland, Nkewllw-ezunaka Onitsha, Anambra Nigeria</span>
              </li>
              <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1050">
                <span className="contact-list-icon bg-light2 dark:bg-dark2">
                  <FaPhone />
                </span>{" "}
                09034334663
              </li>
              <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1100">
                <span className="contact-list-icon bg-light2 dark:bg-dark2">
                  <FaWhatsapp />
                </span>{" "}
                <span>07054974199</span>
              </li>
              <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1150">
                <span className="contact-list-icon bg-light2 dark:bg-dark2">
                  <FaEnvelopeOpen />
                </span>
                <span>emekaodigbo@gmail.com</span>
              </li>
            </ul>
          </div>
          <div className="contact-form">
            <form className="form-list-item-container" onSubmit={handleSubmit}>
              <div className="form-list-item" data-aos="fade-left" data-aos-duration="1000">
                <label>Full name: </label>
                <input
                  className="bg-light2 dark:bg-dark2 outline-none"
                  type="text"
                  name="name"
                  placeholder="Full name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-list-item" data-aos="fade-left" data-aos-duration="1050">
                <label>Email: </label>
                <input
                  className="bg-light2 dark:bg-dark2 outline-none"
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-list-item" data-aos="fade-left" data-aos-duration="1100">
                <label>Subject: </label>
                <input
                  className="bg-light2 dark:bg-dark2 outline-none"
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-list-item" data-aos="fade-left" data-aos-duration="1150">
                <label>Message: </label>
                <textarea
                  className="bg-light2 dark:bg-dark2 outline-none"
                  name="message"
                  placeholder="Your Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
              <div className="form-list-item" data-aos="fade-left" data-aos-duration="1150">
                <button
                  type="submit"
                  className={`btn my-2 ${loading ? "opacity-50" : "opacity-100"}`}
                  disabled={loading}
                >
                  {loading ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>
            {feedbackMessage && (
              <div
                className={`relative mt-4 p-4 rounded ${
                  feedbackMessage.type === "success"
                    ? "bg-green-100 text-green-700"
                    : "bg-red-100 text-red-700"
                }`}
              >
                <button
                  className="absolute top-2 right-2 text-xl font-bold text-dark2 dark:text-light1"
                  onClick={() => setFeedbackMessage(null)}
                >
                  &times;
                </button>
                <p>{feedbackMessage.text}</p>
                <div
                  className="h-1 bg-gray-400 mt-2 rounded"
                  style={{
                    width: `${autoCloseTimer}%`,
                    transition: "width 0.05s linear",
                  }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;













// import "../../styles/Contact.css";
// import { useState } from "react";
// import { FaPhone, FaLocationArrow, FaEnvelopeOpen, FaWhatsapp } from "react-icons/fa";
// import { collection, addDoc } from "firebase/firestore"; // Firebase Firestore
// import { db } from "../../firebase/firebaseConfig"; // Import your Firebase configuration
// import emailjs from "emailjs-com"; // For sending emails

// function Contact() {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     subject: "",
//     message: "",
//   });
//   const [loading, setLoading] = useState(false);
//   const [feedbackMessage, setFeedbackMessage] = useState(null);

//   // Handle form data changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setFeedbackMessage(null);

//     try {
//       // Send email using EmailJS
//       await emailjs.send(
//         "service_yourServiceId", // Replace with your EmailJS Service ID
//         "template_yourTemplateId", // Replace with your EmailJS Template ID
//         {
//           from_name: formData.name,
//           subject: formData.subject,
//           message: formData.message,
//           reply_to: formData.email,
//         },
//         "your_public_key" // Replace with your EmailJS Public Key
//       );

//       // Save the data to Firestore
//       await addDoc(collection(db, "contactMessages"), {
//         name: formData.name,
//         email: formData.email,
//         subject: formData.subject,
//         message: formData.message,
//         timestamp: new Date(),
//       });

//       setFeedbackMessage({ type: "success", text: "Message sent successfully!" });
//       setFormData({ name: "", email: "", subject: "", message: "" });
//     } catch (error) {
//       console.error("Error submitting the message:", error);
//       setFeedbackMessage({ type: "error", text: "Failed to send the message. Please try again." });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <section className="contact-section text-dark2 dark:text-light1" id="contact-section">
//       <div className="contact-div">
//         <h1 className="contact-h1" data-aos="fade-in" data-aos-duration="1000">
//           Contact
//         </h1>
//         <h2 className="contact-h2" data-aos="fade-up" data-aos-duration="1100">
//           Get a question? Contact our customer care representative.
//         </h2>
//         <div className="contact-div2">
//           <div className="contact-details">
//             <ul className="contact-list-item-container">
//               <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1000">
//                 <span className="contact-list-icon bg-light2 dark:bg-dark2">
//                   <FaLocationArrow />
//                 </span>{" "}
//                 <span>No5 Maryland, Nkewllw-ezunaka Onitsha, Anambra Nigeria</span>
//               </li>
//               <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1050">
//                 <span className="contact-list-icon bg-light2 dark:bg-dark2">
//                   <FaPhone />
//                 </span>{" "}
//                 09034334663
//               </li>
//               <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1100">
//                 <span className="contact-list-icon bg-light2 dark:bg-dark2">
//                   <FaWhatsapp />
//                 </span>{" "}
//                 <span>07054974199</span>
//               </li>
//               <li className="contact-list-item" data-aos="fade-right" data-aos-duration="1150">
//                 <span className="contact-list-icon bg-light2 dark:bg-dark2">
//                   <FaEnvelopeOpen />
//                 </span>
//                 <span>emekaodigbo@gmail.com</span>
//               </li>
//             </ul>
//           </div>
//           <div className="contact-form">
//             <form className="form-list-item-container" onSubmit={handleSubmit}>
//               <div className="form-list-item" data-aos="fade-left" data-aos-duration="1000">
//                 <label>Full name: </label>
//                 <input
//                   className="bg-light2 dark:bg-dark2 outline-none"
//                   type="text"
//                   name="name"
//                   placeholder="Full name"
//                   value={formData.name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="form-list-item" data-aos="fade-left" data-aos-duration="1050">
//                 <label>Email: </label>
//                 <input
//                   className="bg-light2 dark:bg-dark2 outline-none"
//                   type="email"
//                   name="email"
//                   placeholder="Email"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="form-list-item" data-aos="fade-left" data-aos-duration="1100">
//                 <label>Subject: </label>
//                 <input
//                   className="bg-light2 dark:bg-dark2 outline-none"
//                   type="text"
//                   name="subject"
//                   placeholder="Subject"
//                   value={formData.subject}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div className="form-list-item" data-aos="fade-left" data-aos-duration="1150">
//                 <label>Message: </label>
//                 <textarea
//                   className="bg-light2 dark:bg-dark2 outline-none"
//                   name="message"
//                   placeholder="Your Message"
//                   value={formData.message}
//                   onChange={handleChange}
//                   required
//                 ></textarea>
//               </div>
//               <div className="form-list-item" data-aos="fade-left" data-aos-duration="1150">
//                 <button
//                   type="submit"
//                   className={`btn my-2 ${loading ? "opacity-50" : "opacity-100"}`}
//                   disabled={loading}
//                 >
//                   {loading ? "Sending..." : "Send Message"}
//                 </button>
//               </div>
//             </form>
//             {feedbackMessage && (
//               <div
//                 className={`mt-4 p-4 rounded ${
//                   feedbackMessage.type === "success"
//                     ? "bg-green-100 text-green-700"
//                     : "bg-red-100 text-red-700"
//                 }`}
//               >
//                 {feedbackMessage.text}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// export default Contact;












